/** @jsx jsx */
import { Component, h } from 'preact'
import { useMemo } from 'preact/hooks'
import { observer } from 'mobx-react-lite'
import { jsx, css } from '@emotion/react'

import { useController, Filter } from '@searchspring/snap-preact-components'

import './desktopfiltersummary.css'
import classnames from 'classnames'

import { markPlpFacetFilterInteraction } from '../../middleware/plpFacetScrollMarkers'

export const DesktopFilterSummary = () => {
    const controller = useController()

    const { filters } = controller.store
    const { facets } = controller.store

    const { urlManager } = controller

    const removeFilter = (e, filter) => {
        markPlpFacetFilterInteraction()
        const query = `filter.${filter.field}`
        urlManager.remove(query, filter.value).go()
    }

    const clearAll = () => {
        markPlpFacetFilterInteraction()
        urlManager.remove('filter').go()
    }

    let facetLabel;
    
    return (
        <div className={classnames('desktop-filter-summary', {
          'articles-summary': controller.store.config?.id === "articles",
        })}>
            {filters.length > 0 && (
                <div class="clear-all">
                    <button onClick={clearAll}>Clear All</button>
                </div>
            )}
            <span class="active-filters">
                {filters.map(filter => {
                    return (
                      <div>
                        { facets.map(facet => {
                          if( facet.field == filter.field) {
                            facetLabel = facet.label;
                          } 
                        })}

                        <button onClick={e => removeFilter(e, filter)}>
                          <Filter
                            filter={filter}
                            facetLabel={facetLabel}
                            valueLabel={filter.label}
                            separator={': '}
                          />
                        </button>
                      </div>
                    )
                })}
            </span>
      </div>
    )
}
